function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "background",
  transform: "translate(1, .15)",
  width: 52.73,
  height: 52.73,
  rx: 27.365,
  fill: "#1bd741"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.5 6)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_210",
  "data-name": "Caminho 210",
  d: "M76.49,104.64l2.682-9.521a19.112,19.112,0,1,1,7.138,6.993Zm10.328-6L87.4,99a15.867,15.867,0,1,0-5.115-5l.394.614L81.139,100.1Z",
  transform: "translate(-76.49 -66.32)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_211",
  "data-name": "Caminho 211",
  d: "M159.864,150.89l-1.244-.068a1.5,1.5,0,0,0-1.066.36,5.663,5.663,0,0,0-1.858,2.847c-.441,1.961.24,4.363,2,6.765a20.13,20.13,0,0,0,10.848,7.887,5.307,5.307,0,0,0,4.485-.546,4,4,0,0,0,1.743-2.542l.2-.925a.643.643,0,0,0-.36-.721l-4.2-1.937a.645.645,0,0,0-.778.191l-1.65,2.138a.471.471,0,0,1-.53.159,12.889,12.889,0,0,1-6.973-5.967.473.473,0,0,1,.06-.531l1.572-1.819a.64.64,0,0,0,.1-.673l-1.8-4.227A.641.641,0,0,0,159.864,150.89Z",
  transform: "translate(-146.069 -140.671)",
  fill: "#fff"
})));

function SvgWppButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.73 54.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWppButton);
export default __webpack_public_path__ + "static/media/wppButton.fd1dfd64.svg";
export { ForwardRef as ReactComponent };